import React from "react";
import * as styles from "./NotificationItem.module.css";

/**
 * 알림 항목 컴포넌트
 *
 * @param {string} title - 알림 제목
 * @param {string} message - 알림 메시지
 * @param {string} date - 알림 날짜
 * @param {function} onClick - 클릭 이벤트 처리 함수
 */
const NotificationItem = ({ title, message, date, onClick }) => (
    <div className={styles.notification} onClick={onClick}>
        <div className={styles.icon}>✓</div>
        <div className={styles.content}>
            <div className={styles.title}>{`${title} ・ ${date}`}</div>
            <div className={styles.message}>
                <span>{message}</span>
            </div>
        </div>
    </div>
);

export default NotificationItem;